/**
 * @generated SignedSource<<98128f32457a5302b0fe1a83c7659db9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FullName_name$data = {
  readonly displayUsername: string;
  readonly firstName: string | null;
  readonly hasActivePortfolioSubscription: boolean;
  readonly lastName: string | null;
  readonly visitorCanEdit: boolean;
  readonly " $fragmentType": "FullName_name";
};
export type FullName_name$key = {
  readonly " $data"?: FullName_name$data;
  readonly " $fragmentSpreads": FragmentRefs<"FullName_name">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FullName_name",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayUsername",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitorCanEdit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasActivePortfolioSubscription",
      "storageKey": null
    }
  ],
  "type": "UserProfile",
  "abstractKey": null
};

(node as any).hash = "37be8d1596de23522a2416d3a3269eee";

export default node;
